<!-- Header de página -->
<div class="page-header">
    <div class="d-flex justify-content-between align-items-center">
        <div>
            <h1 class="page-title">RESERVAS</h1>
            <p class="page-subtitle text-muted">
                Gestión y consulta de bookings y cargas asociadas
            </p>
        </div>
        <div class="header-actions">
            <button
                mat-raised-button
                color="primary"
                (click)="exportExcel()"
                matTooltip="Exportar registros del filtro actual a Excel"
            >
                <mat-icon>file_download</mat-icon>
                Excel
            </button>
        </div>
    </div>
</div>

<div class="page-body">
    <!-- Filtros de búsqueda -->
    <mat-card class="filters-card">
        <mat-card-header>
            <mat-card-title>
                <mat-icon>filter_list</mat-icon>
                Filtros de Búsqueda
            </mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div class="filters-section">
                <div class="filters-grid filters-grid-4">
                    <!-- Primera fila: Cliente, Exportador, Nave, Naviera -->
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Cliente</mat-label>
                        <input
                            type="text"
                            matInput
                            [formControl]="filterClient"
                            [matAutocomplete]="autoClient"
                        />
                        <mat-autocomplete
                            #autoClient="matAutocomplete"
                            [displayWith]="displayFn"
                        >
                            <mat-option
                                *ngFor="let option of filteredClients | async"
                                [value]="option"
                            >
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>business</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Exportador</mat-label>
                        <input
                            type="text"
                            matInput
                            [formControl]="filterExporter"
                            [matAutocomplete]="autoExporter"
                        />
                        <mat-autocomplete
                            #autoExporter="matAutocomplete"
                            [displayWith]="displayFn"
                        >
                            <mat-option
                                *ngFor="let option of filteredExporters | async"
                                [value]="option"
                            >
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>local_shipping</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Nave</mat-label>
                        <input
                            type="text"
                            matInput
                            [formControl]="filterVessel"
                            [matAutocomplete]="autoVessel"
                        />
                        <mat-autocomplete
                            #autoVessel="matAutocomplete"
                            [displayWith]="displayFn"
                        >
                            <mat-option
                                *ngFor="let option of filteredVessels | async"
                                [value]="option"
                            >
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>directions_boat</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Naviera</mat-label>
                        <input
                            type="text"
                            matInput
                            [formControl]="filterCarrier"
                            [matAutocomplete]="autoCarrier"
                        />
                        <mat-autocomplete
                            #autoCarrier="matAutocomplete"
                            [displayWith]="displayFn"
                        >
                            <mat-option
                                *ngFor="let option of filteredCarriers | async"
                                [value]="option"
                            >
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>directions_boat</mat-icon>
                    </mat-form-field>

                    <!-- Segunda fila: Nro Booking, Nro BL, POL, POD -->
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Nro Booking</mat-label>
                        <input
                            matInput
                            [formControl]="filterBookingNumber"
                            placeholder="Buscar por booking"
                        />
                        <mat-icon matSuffix>confirmation_number</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Nro BL</mat-label>
                        <input
                            matInput
                            [formControl]="filterBlNumber"
                            placeholder="Buscar por BL"
                        />
                        <mat-icon matSuffix>description</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>POL</mat-label>
                        <input
                            type="text"
                            matInput
                            [formControl]="filterPol"
                            [matAutocomplete]="autoPol"
                        />
                        <mat-autocomplete
                            #autoPol="matAutocomplete"
                            [displayWith]="displayFn"
                        >
                            <mat-option
                                *ngFor="let option of filteredPol | async"
                                [value]="option"
                            >
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>anchor</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>POD</mat-label>
                        <input
                            type="text"
                            matInput
                            [formControl]="filterPod"
                            [matAutocomplete]="autoPod"
                        />
                        <mat-autocomplete
                            #autoPod="matAutocomplete"
                            [displayWith]="displayFn"
                        >
                            <mat-option
                                *ngFor="let option of filteredPod | async"
                                [value]="option"
                            >
                                {{ option.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>anchor</mat-icon>
                    </mat-form-field>

                    <!-- Tercera fila: Fechas y Estado/Temporada -->
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Fecha Desde</mat-label>
                        <input
                            matInput
                            [matDatepicker]="pickerFrom"
                            [formControl]="filterDateFrom"
                            readonly
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="pickerFrom"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #pickerFrom></mat-datepicker>
                        <mat-hint *ngIf="datesLockedBySearch">No disponible con Nro. Booking/BL</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Fecha Hasta</mat-label>
                        <input
                            matInput
                            [matDatepicker]="pickerTo"
                            [formControl]="filterDateTo"
                            readonly
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="pickerTo"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #pickerTo></mat-datepicker>
                        <mat-hint *ngIf="datesLockedBySearch">No disponible con Nro. Booking/BL</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Estado</mat-label>
                        <mat-select [formControl]="filterStatus" multiple>
                            <mat-option
                                *ngFor="let status of statusesOptions"
                                [value]="status.name"
                            >
                                {{ status.name }}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix>info</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Temporada</mat-label>
                        <mat-select [formControl]="filterSeason">
                            <mat-option value="">Todas</mat-option>
                            <mat-option
                                *ngFor="let season of seasonsOptions"
                                [value]="season.seasonId"
                            >
                                {{ season.seasonName }}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix>calendar_today</mat-icon>
                    </mat-form-field>
                </div>

                <div class="filter-actions">
                    <button
                        mat-raised-button
                        color="primary"
                        (click)="applyFilters()"
                        [disabled]="isLoading"
                    >
                        <mat-icon>search</mat-icon>
                        Buscar
                    </button>
                    <button
                        mat-raised-button
                        color="warn"
                        (click)="clearFilters()"
                        [disabled]="isLoading"
                    >
                        <mat-icon>clear</mat-icon>
                        Limpiar
                    </button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Tabla de datos -->
    <mat-card class="data-card">
        <mat-card-content>
            <!-- Estado de carga -->
            <div class="loading-container" *ngIf="isLoading">
                <div class="loading-spinner">
                    <mat-spinner diameter="48"></mat-spinner>
                    <p>Cargando reservas...</p>
                </div>
            </div>

            <!-- Error state -->
            <div *ngIf="hasError && !isLoading" class="error-container">
                <mat-icon color="warn">error</mat-icon>
                <h3>Error al cargar datos</h3>
                <p>{{ errorMessage }}</p>
                <button
                    mat-raised-button
                    color="primary"
                    (click)="searchBookings()"
                >
                    <mat-icon>refresh</mat-icon>
                    Reintentar
                </button>
            </div>

            <div
                class="liquidaciones-list-table"
                *ngIf="!isLoading && !hasError"
            >
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" class="w-full">
                        <!-- Booking Column -->
                        <ng-container matColumnDef="bookingNumber">
                            <th mat-header-cell *matHeaderCellDef>
                                Reserva OPB
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <strong>{{ element.id }}</strong> /
                                {{ element.versionNumber }}
                            </td>
                        </ng-container>

                        <!-- Client Column -->
                        <ng-container matColumnDef="clientName">
                            <th mat-header-cell *matHeaderCellDef>Cliente</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.clientName || '-' }}
                            </td>
                        </ng-container>

                        <!-- Status Column -->
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>Estado</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.status || '-' }}
                            </td>
                        </ng-container>

                        <!-- Exporter Column -->
                        <ng-container matColumnDef="exporterName">
                            <th mat-header-cell *matHeaderCellDef>
                                Exportador
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.exporterName || '-' }}
                            </td>
                        </ng-container>

                        <!-- Carrier Column -->
                        <ng-container matColumnDef="carrierName">
                            <th mat-header-cell *matHeaderCellDef>Naviera</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.carrierName || '-' }}
                            </td>
                        </ng-container>

                        <!-- Nave-Viaje Column -->
                        <ng-container matColumnDef="vesselName">
                            <th mat-header-cell *matHeaderCellDef>
                                Nave-Viaje
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.vesselName || '-' }}
                                <span *ngIf="element.voyageNumber">{{
                                    element.voyageNumber
                                }}</span>
                            </td>
                        </ng-container>

                        <!-- Date Column (ETD) -->
                        <ng-container matColumnDef="bookingDate">
                            <th mat-header-cell *matHeaderCellDef>ETD</th>
                            <td mat-cell *matCellDef="let element">
                                {{ formatDate(element.bookingDate) }}
                            </td>
                        </ng-container>

                        <!-- POL Column -->
                        <ng-container matColumnDef="polName">
                            <th mat-header-cell *matHeaderCellDef>POL</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.polName || '-' }}
                            </td>
                        </ng-container>

                        <!-- POD Column -->
                        <ng-container matColumnDef="podName">
                            <th mat-header-cell *matHeaderCellDef>POD</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.podName || '-' }}
                            </td>
                        </ng-container>

                        <!-- External Booking Column -->
                        <ng-container matColumnDef="externalBookingNumber">
                            <th mat-header-cell *matHeaderCellDef>
                                Nro. reserva
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.externalBookingNumber || '-' }}
                            </td>
                        </ng-container>

                        <!-- Commodity Column -->
                        <ng-container matColumnDef="commodity">
                            <th mat-header-cell *matHeaderCellDef>Especie</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.commodity || '-' }}
                            </td>
                        </ng-container>

                        <!-- Cntrs Column -->
                        <ng-container matColumnDef="containerCount">
                            <th mat-header-cell *matHeaderCellDef>Cntrs.</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.containerCount || 0 }}
                            </td>
                        </ng-container>

                        <!-- Actions Column -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Acciones</th>
                            <td mat-cell *matCellDef="let element">
                                <button
                                    mat-button
                                    color="primary"
                                    (click)="viewDetail(element.id)"
                                    matTooltip="Ver detalle"
                                >
                                    <mat-icon>visibility</mat-icon>
                                    VER
                                </button>
                            </td>
                        </ng-container>

                        <tr
                            mat-header-row
                            *matHeaderRowDef="displayedColumns"
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: displayedColumns"
                        ></tr>
                    </table>
                </div>

                <div *ngIf="dataSource.data.length === 0" class="no-data">
                    <mat-icon>search_off</mat-icon>
                    <h3>No se encontraron reservas</h3>
                    <p>Intente ajustar los filtros de búsqueda.</p>
                    <button
                        mat-raised-button
                        color="primary"
                        (click)="clearFilters()"
                    >
                        <mat-icon>clear</mat-icon>
                        Limpiar filtros
                    </button>
                </div>
            </div>

            <mat-paginator
                [length]="totalRegistros"
                [pageSize]="elementosPorPagina"
                [pageSizeOptions]="[5, 10, 25, 100]"
                (page)="onPageChange($event)"
            >
            </mat-paginator>
        </mat-card-content>
    </mat-card>
</div>

<!-- Overlay de carga para generación de Excel -->
<div *ngIf="isGeneratingExcel" class="excel-loading-overlay">
    <div class="excel-loading-content">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="excel-loading-text">Generando Archivo Excel...</p>
    </div>
</div>
